/*
  // 文件相关错误
  FILE_NOT_FOUND = 0 [(errors.code) = 404];
  FILE_FORBIDDEN = 1 [(errors.code) = 403];
  FILE_NOT_READY = 2 [(errors.code) = 400];
  FILE_EXPIRED = 3 [(errors.code) = 410];
  FILE_MISSING_TYPE = 4 [(errors.code) = 400];
  FILE_MISSING_NAME = 5 [(errors.code) = 400];
  FILE_MISSING_ID = 6 [(errors.code) = 400];
  FILE_INVALID_EXTENSION = 7 [(errors.code) = 400];

  // 任务相关错误
  JOB_NOT_FOUND = 10 [(errors.code) = 404];
  JOB_FORBIDDEN = 11 [(errors.code) = 403];
  JOB_BAD_STATUS = 12 [(errors.code) = 400];
  JOB_MISSING_PARAMS = 13 [(errors.code) = 400];
  JOB_UNSUPPORTED_ADAPTER = 14 [(errors.code) = 400];
  JOB_MISSING_ID = 15 [(errors.code) = 400];

  // 认证相关错误
  AUTH_INVALID_TICKET = 20 [(errors.code) = 401];
  AUTH_MISSING_TOKEN = 21 [(errors.code) = 401];
  AUTH_INVALID_TOKEN = 22 [(errors.code) = 401];
  AUTH_UNAUTHORIZED = 23 [(errors.code) = 401];
  AUTH_MISSING_CTICKET = 24 [(errors.code) = 400];
  AUTH_INVALID_CONTEXT = 25 [(errors.code) = 500];


*/

export enum ErrorReason {
  FILE_NOT_FOUND = 'FILE_NOT_FOUND',
  FILE_FORBIDDEN = 'FILE_FORBIDDEN',
  FILE_NOT_READY = 'FILE_NOT_READY',
  FILE_EXPIRED = 'FILE_EXPIRED',
  FILE_MISSING_TYPE = 'FILE_MISSING_TYPE',
  FILE_MISSING_NAME = 'FILE_MISSING_NAME',
  FILE_MISSING_ID = 'FILE_MISSING_ID',
  FILE_INVALID_EXTENSION = 'FILE_INVALID_EXTENSION',
  JOB_NOT_FOUND = 'JOB_NOT_FOUND',
  JOB_FORBIDDEN = 'JOB_FORBIDDEN',
  JOB_BAD_STATUS = 'JOB_BAD_STATUS',
  JOB_MISSING_PARAMS = 'JOB_MISSING_PARAMS',
  JOB_UNSUPPORTED_ADAPTER = 'JOB_UNSUPPORTED_ADAPTER',
  JOB_MISSING_ID = 'JOB_MISSING_ID',
  AUTH_INVALID_TICKET = 'AUTH_INVALID_TICKET',
  AUTH_MISSING_TOKEN = 'AUTH_MISSING_TOKEN',
  AUTH_INVALID_TOKEN = 'AUTH_INVALID_TOKEN',
  AUTH_UNAUTHORIZED = 'AUTH_UNAUTHORIZED',
  AUTH_MISSING_CTICKET = 'AUTH_MISSING_CTICKET',
  AUTH_INVALID_CONTEXT = 'AUTH_INVALID_CONTEXT',
}

export const API_ERROR_MESSAGE = {
  [ErrorReason.FILE_NOT_FOUND]: '文件不存在',
  [ErrorReason.FILE_FORBIDDEN]: '文件禁止访问',
  [ErrorReason.FILE_NOT_READY]: '文件未准备好',
  [ErrorReason.FILE_EXPIRED]: '文件已过期',
  [ErrorReason.FILE_MISSING_TYPE]: '文件类型缺失',
  [ErrorReason.FILE_MISSING_NAME]: '文件名称缺失',
  [ErrorReason.FILE_MISSING_ID]: '文件ID缺失',
  [ErrorReason.FILE_INVALID_EXTENSION]: '文件扩展名无效',
  [ErrorReason.JOB_NOT_FOUND]: '任务不存在',
  [ErrorReason.JOB_FORBIDDEN]: '任务禁止访问',
  [ErrorReason.JOB_BAD_STATUS]: '任务状态异常',
  [ErrorReason.JOB_MISSING_PARAMS]: '任务参数缺失',
  [ErrorReason.JOB_UNSUPPORTED_ADAPTER]: '不支持的适配器',
  [ErrorReason.JOB_MISSING_ID]: '未找到任务',
  [ErrorReason.AUTH_INVALID_TICKET]: 'Ticket 无效',
  [ErrorReason.AUTH_MISSING_TOKEN]: '身份认证失败',
  [ErrorReason.AUTH_INVALID_TOKEN]: '非法身份',
  [ErrorReason.AUTH_UNAUTHORIZED]: '未授权',
  [ErrorReason.AUTH_MISSING_CTICKET]: '未授权',
  [ErrorReason.AUTH_INVALID_CONTEXT]: '非法参数',
};

export const TOKEN_VALID_REASON = [
  ErrorReason.AUTH_INVALID_TICKET,
  ErrorReason.AUTH_MISSING_TOKEN,
  ErrorReason.AUTH_INVALID_TOKEN,
  ErrorReason.AUTH_UNAUTHORIZED,
  ErrorReason.AUTH_MISSING_CTICKET,
  ErrorReason.AUTH_INVALID_CONTEXT,
];
